export const LOCAL_STORAGE_ALIAS_KEY = "randomAlias";
export const LOCAL_STORAGE_TIME_KEY = "setupTime";
